import {
    ACTION_WELCOME,
    ACTION_UPDATE_MARCAEMPRESARIAL, 
    ACTION_CREATE_MARCAEMPRESARIAL,
    SET_WELCOME,
    SET_MARCA
} from "@/views/home/store/types/types.js";

import config from "@/views/home/config/home_api.js";
import EventBus  from '@/utils/event_bus.js'; 
import axios from '@/plugins/http/axios.js';
import PathUri from '@/utils/path_uri';
import Swal from 'sweetalert2';

const _pathUri = new PathUri(config.port, config.context);
import { HomeService } from "../../../services";

const actions = {

    [ACTION_WELCOME]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HomeService.getHome( idGroup, idEmpresa, idUsuario )
                .then(resp => {
                    const welcome = resp.data.payload;
                    commit(SET_WELCOME, welcome);
                    const roleId = resp.data.payload.role.roleId;
                    sessionStorage.setItem('roleId', roleId);
                    resolve(resp.data.payload)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },

    [ACTION_CREATE_MARCAEMPRESARIAL]: async ({ state, commit }, payload) => {
              
        return new Promise((resolve, reject) => {
            state.loadingMarca = true;
            const formdata = new FormData();
            formdata.append("imageFile", payload.welcomeImageUrl);
            formdata.append("titulo", payload.welcomeTitle);
            formdata.append("cuerpo", payload.welcomeBody);
            axios({
                    method: 'post',
                    url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")+'/empresas/crear/marcaempresarial'}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    },
                    data: formdata,
                    redirect: 'follow'
                })
                .then(resp => {
                    
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'La Marca Empresarial fue creada exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    })
                    const dataMarca = resp.data.payload;
                    commit(SET_MARCA, dataMarca);
                    EventBus.$emit('marca-succesfull');
                    resolve(resp)
                })
                .catch(err => {
                    EventBus.$emit('marca-error');
                    reject(err)
                })
                .finally(() => state.loadingMarca = false);
        })
    },

    [ACTION_UPDATE_MARCAEMPRESARIAL]: ({ state, commit }, payload) => {

        return new Promise((resolve, reject) => {
            state.loadingMarca = true;
            const formdata = new FormData();
            formdata.append("imageFile", payload.welcomeImageUrl);
            formdata.append("titulo", payload.welcomeTitle);
            formdata.append("cuerpo", payload.welcomeBody);
            axios({
                    method: 'post',
                    url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")+'/empresas/actualizar/marcaempresarial'}`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    },
                    data: formdata,
                    redirect: 'follow'
                })
                .then(resp => {
                    
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'La Marca Empresarial fue actualizada exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    })
                    const dataMarca = resp.data.payload;
                    commit(SET_MARCA, dataMarca);
                    EventBus.$emit('marca-succesfull');
                    resolve(resp)
                })
                .catch(err => {
                    EventBus.$emit('marca-error');
                    reject(err)
                })
                .finally(() => state.loadingMarca = false);
        })
    }
}

export default actions;